import React, { useCallback, useRef, useState } from 'react'
import classNames from 'classnames'
import { ExternalLink } from '@/atoms/ExternalLink'
import { Image } from '@/atoms/Image'
import { LinkViewModel } from '@/services/RenderService/types'
import { ReactFCC } from '@/types/react'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'

interface Props extends React.HTMLAttributes<HTMLElement> {
  linkModel: LinkViewModel
  onClick?: () => void
}

export const SquareTileCard: ReactFCC<Props> = ({ children, className, linkModel, onClick, ...props }) => {
  const [isLoadingImage, setLoadingImage] = useState(true)
  const cardRef = useRef<HTMLDivElement>(null)

  const onLoadComplete = useCallback(() => setLoadingImage(false), [])

  return (
    <div {...props} onClick={onClick} ref={cardRef} className={classNames('relative', className)}>
      <ExternalLink href={linkModel.linkUrl}>
        <div
          className={classNames(
            'relative cursor-pointer overflow-hidden rounded-lg bg-cover duration-[400ms] ease-in-out hover:z-10 md:hover:scale-[1.05]',
            className,
          )}
        >
          <div className={classNames(['relative w-full bg-black rounded-lg', isLoadingImage ? 'animate-pulse' : ''])}>
            <div className="relative w-full">
              <div className="pt-[100%]" />
              <div className="absolute inset-0">
                {linkModel.imageUrl && (
                  <Image
                    src={getCloudinaryImageUrl({ path: linkModel.imageUrl ?? '', width: 500, height: 500 })}
                    className={classNames(['object-cover rounded-lg absolute top-0 left-0 h-full w-full'])}
                    alt={linkModel.alt as string}
                    onLoad={onLoadComplete}
                    width={400}
                    height={400}
                  />
                )}
              </div>
            </div>
            {children}
          </div>
        </div>
      </ExternalLink>
    </div>
  )
}

export default SquareTileCard
